import styled from 'styled-components';

export const TotalValue = styled.h1`
  margin-left: auto;
  margin-top: 10px;
  font-size: 18pt;
`;
